import Web3 from 'web3'

export const getWeb3Instance = (provider: string) => {
  const web3Instance = new Web3(new Web3.providers.HttpProvider(provider))
  return web3Instance
}
